import React, { useEffect, useState } from "react";
import { MdArrowBack, MdDelete, MdErrorOutline } from "react-icons/md";
import { useToast } from "../../controls/Toast/ToastService";
import Container from "../../base/Container";
import Card from "../../controls/Card";
import { GetAllByUser, Remove } from "../../../configurations/crud/opdCentersCrud";
import LoadingContainer from "../../controls/LoadingContainer";
import StatusContainer from "../../controls/StatusContainer";
import { CiLocationArrow1 } from "react-icons/ci";
import {
  EDoctorStatusBg,
  GetEDoctorStatusName,
} from "../../../configurations/enums/EDoctorStatus";
import { RiEditBoxFill } from "react-icons/ri";
import DeleteCenterModal from "./DeleteCenterModal";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import { GetEOpdDaysName } from "../../../configurations/enums/EOpdDays";
import { EOPDCenterStatusBg, GetEOPDCenterStatusName } from "../../../configurations/enums/EOPDCenterStatus";
import useGlobalLoader from "../../../configurations/useGlobalLoader";
import { EBoolBg, GetEBoolName } from "../../../configurations/enums/EBool";
import { EDayTypeBg, GetETypeDays } from "../../../configurations/enums/EOpdType";

export default function CenterAllByUser() {
  const { start, end } = useGlobalLoader()
  const navigate = useNavigate()
  const [opdCenters, setOpdCenter] = useState([]);
  const [user, setUser] = useState();
  const [loding, setLoding] = useState(false);
  const toast = useToast();
  const [lodingCrud, setLodingCrud] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [editData, setEditData] = useState({
    id: 0,
    name: "",
    shortName: "",
    priority: "0",
  });

  useEffect(() => {
    getAllOpdCenters();
  }, []);

  function getAllOpdCenters() {
    setLoding(true);
    start()
    GetAllByUser()
      .then((res) => {
        let mdata = res.data;
        if (mdata.result.succeeded) {
          if (mdata.data.length > 0)
            setUser(mdata.data[0].user);
          setOpdCenter(mdata.data);
        } else {
          setOpdCenter([]);
          toast.open(mdata.result.message, <MdErrorOutline />, "danger");
        }
        setLoding(false);
        end()
      })
      .catch((errors) => {
        setOpdCenter([]);
        setLoding(false);
        end()
        toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
      });
  }

  const doRefresh = () => {
    getAllOpdCenters();
  };

  const handleDelete = (id) => {
    setLodingCrud(true)
    start()
    Remove(id).then(res => {
      let mdata = res.data
      if (mdata.succeeded) {
        setIsOpenDelete(false)
        doRefresh()
        toast.open("Center deleted successfully.", <IoCheckmarkDoneCircleOutline />, "success")
      } else {
        toast.open("You can not delete those centers which are consume by other task", <MdErrorOutline />, "danger")
      }
      setLodingCrud(false)
      end()
    }).catch(errors => {
      setLodingCrud(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  return (
    <Container
      heading={
        <>
          Profile <CiLocationArrow1 />
        </>
      }
    >
      <div className="flex flex-col w-full">
        <div class="">
          <div className='flex space-x-2 mb-2'>
            <div className="w-32">
              <Link to="/opdcenters/add" className='btn-success my-2 mr-2'>Add Center</Link>
            </div>
          </div>
        </div>
        {!loding ? (
          <>
            <div class="grid md:grid-cols-2 gap-5 w-full">
              {opdCenters.map((item, index) => (
                <>
                  <div class="w-full">
                    <Card
                      isBorder={true}
                      borderColor="border-green-300"
                      title={item.centerName}
                    >
                      <div class="text-gray-700">
                        <div class="grid text-sm">
                          <div class="flex">
                            <div class="w-4/12 px-4 py-2 font-semibold"> Center Id</div>
                            <div class="w-8/12 px-4 py-2">{item.id}</div>
                          </div>
                          <div class="flex">
                            <div class="w-4/12 px-4 py-2 font-semibold">Register Appointment</div>
                            <div class="w-8/12 px-4 py-2">{moment(item.startPuttingAppointment).format("LT")} - {moment(item.endPuttingAppointment).format("LT")}</div>
                          </div>
                          <div class="flex">
                            <div class="w-4/12 px-4 py-2 font-semibold">OPD Timing</div>
                            <div class="w-8/12 px-4 py-2">{moment(item.opdStartTime).format("LT")} - {moment(item.opdEndTime).format("LT")}</div>
                          </div>
                          <div class="flex">
                            <div class="w-4/12 px-4 py-2 font-semibold">Patient Late Count</div>
                            <div class="w-8/12 px-4 py-2">{item.moveLateCount}</div>
                          </div>
                          <div class="flex">
                            <div class="w-4/12 px-4 py-2 font-semibold">Open</div>
                            <div class="w-8/12 px-4 py-2 space-x-1">
                              {
                                item.opdDays.split(',').map((item, index) =>
                                  <>
                                    {index != 0 && " ,"}{GetEOpdDaysName(item.trim())}
                                  </>
                                )
                              }</div>
                          </div>
                          <div class="flex">
                            <div class="w-4/12 px-4 py-2 font-semibold">Address</div>
                            <div class="w-8/12 px-4 py-2">{item.address},{item.city.name}, {item.city.state.name}, Phone {item.phone}</div>
                          </div>

                          <div class="flex">
                            <div class="w-4/12 px-4 py-2 font-semibold">Doctor Status</div>
                            <div class="w-8/12 px-4 py-2"><StatusContainer bg={EDoctorStatusBg(item.doctorStatus)} text={GetEDoctorStatusName(item.doctorStatus)} /></div>
                          </div>
                          <div class="flex">
                            <div class="w-4/12 px-4 py-2 font-semibold">Center Status</div>
                            <div class="w-8/12 px-4 py-2"><StatusContainer bg={EOPDCenterStatusBg(item.status)} text={GetEOPDCenterStatusName(item.status)} /></div>
                          </div>
                          <div class="flex">
                            <div class="w-4/12 px-4 py-2 font-semibold">Opd Register Online</div>
                            <div class="w-8/12 px-4 py-2"><StatusContainer bg={EBoolBg(item.isRegisterOnline)} text={GetEBoolName(item.isRegisterOnline)} /></div>
                          </div>
                          {item.details && <div class="flex">
                            <div class="w-4/12 px-4 py-2 font-semibold">Details</div>
                            <div class="w-8/12 px-4 py-2">{item.details}</div>
                          </div>}
                          <div class="flex">
                            <div class="w-4/12 px-4 py-2 font-semibold">Per Day OPD Limit</div>
                            <div class="w-8/12 px-4 py-2">{item.perDayOPDLimit}</div>
                          </div>
                          <div class="flex">
                            <div class="w-4/12 px-4 py-2 font-semibold">OPD Type</div>
                            <div class="w-8/12 px-4 py-2"><StatusContainer bg={EDayTypeBg(item.opdType)} text={GetETypeDays(item.opdType)} /></div>
                          </div>
                          <div class="flex">
                            <div class="w-4/12 px-4 py-2 font-semibold">Days Count</div>
                            <div class="w-8/12 px-4 py-2">{item.byDaysCount}</div>
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-end">
                        {/* <button
                          type="button"
                          class="cursor-pointer ml-3 text-2xl  text-sky-500 hover:underline mr-1 p-1 hover:bg-gray-200 hover:rounded-lg"
                          title="Change Doctor's Status"
                        >
                          <FaUserEdit />
                        </button>
                        <button
                          type="button"
                          class="cursor-pointer ml-3 text-2xl  text-sky-500 hover:underline mr-1 p-1 hover:bg-gray-200 hover:rounded-lg"
                          title="Change Center's Status"
                        >
                          <TbBookmarkEdit />
                        </button> */}
                        <Link
                          to={"/opdcenters/" + item.id + "/edit"}
                          type="button"
                          class="cursor-pointer ml-3 text-2xl  text-sky-500 hover:underline mr-1 p-1 hover:bg-gray-200 hover:rounded-lg"
                          title="Edit"
                        >
                          <RiEditBoxFill />
                        </Link>
                        <button
                          onClick={() => {
                            setEditData(item);
                            setIsOpenDelete(!isOpenDelete);
                          }}
                          type="button"
                          class="cursor-pointer ml-3 text-2xl  text-red-600 hover:underline mr-1 p-1 hover:bg-gray-200 hover:rounded-lg"
                          title="Delete"
                        >
                          <MdDelete />
                        </button>
                      </div>
                    </Card>
                  </div>
                </>
              ))}
            </div>
            <DeleteCenterModal
              handleDelete={handleDelete}
              isOpen={isOpenDelete}
              setIsOpen={setIsOpenDelete}
              loding={lodingCrud}
              id={editData.id}
              name={editData.centerName}
            />
          </>
        ) :
          <>
            <div class="w-full ">
              <LoadingContainer text={"Getting centers"} />
            </div>
          </>
        }
      </div>
    </Container>
  );
}
